export const NavItems = ["Home", "About Us","Our Services","Free Resources","Careers","Faq","Contact Us"];
